
import type { PropType } from 'vue'
import type { PreTripForCompleteDay } from '@/core/types/tms-graph.types'

import { defineComponent } from 'vue'

type TripsGroupByDate = {
    date: string
    pretrips: Array<PreTripForCompleteDay>
}

export default defineComponent({
    props: {
        group: {
            type: Object as PropType<TripsGroupByDate>,
            required: true,
        }
    },
    emits: ['update'],
    setup(props, { emit }) {
        const onUpdatePretrip = (pretrip: PreTripForCompleteDay) => {
            emit('update', pretrip)
        }

        return {
            onUpdatePretrip
        }
    }
})
